<template>
  <div class="">
    <el-dialog title="价格试算"
               width="900px"
               :visible.sync="visibleValue"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :modal-append-to-body="true"
               :append-to-body="true"
               @closed="closedCallback">
      <el-form :model="searchData"
               ref="searchForm"
               inline
               size="small"
               label-width="120px">
        <el-form-item label="起运城市" :rules="formRules.require" prop="cityId">
          <el-select v-model="searchData.cityId"
                     class="common-input-width"
          >
            <el-option
              v-for="(item, index) in startCityList"
              :key="index"
              :label="item.cityName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="美国目的地邮编" :rules="formRules.require" prop="zipCode">
          <el-input v-model="searchData.zipCode" class="common-input-width"/>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="searchData.address" style="width: 605px" type="textarea"/>
        </el-form-item>
        <br/>
        <el-form-item label="货物总重量" :rules="formRules.weight" prop="goodsWeight">
          <el-input v-model="searchData.goodsWeight" class="common-input-width"/>
        </el-form-item>
        <el-form-item label="货物总体积" :rules="formRules.weight" prop="goodsVolume">
          <el-input v-model="searchData.goodsVolume" class="common-input-width"/>
        </el-form-item>
        <el-form-item label="货物总件数" :rules="formRules.number" prop="goodsNumber">
          <el-input v-model="searchData.goodsNumber" class="common-input-width"/>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" class="common-input-width" @click="clickSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        style="width: 100%"
        :header-cell-style="{ background: '#F3F3F3' }"
        size="small"
      >
        <el-table-column label="序号" type="index" width="50"/>
        <el-table-column label="供应商" property="carrier" min-width="120"/>
        <el-table-column label="报价名称" property="quotedName" width="120">
          <template slot-scope="scope">
            <el-link
              @click="showQuotation(scope.row,scope.$index)"
              type="primary"
              :underline="false">
              查看报价
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="起运城市" property="cityName" width="120"/>
        <el-table-column label="距离" property="distance" width="120"/>
        <el-table-column label="总金额" property="" width="120">
          <div slot="header" slot-scope="scope">
            总金额
            <el-tooltip
              content=""
              placement="top-start"
              effect="dark">
              <i class="el-icon-question"/>
              <div slot="content">
                1.报价为里程区间计费：总金额=单价*货物计费重
                <br/>
                2.报价为里程数计费：总金额=单价*里程数*货物计费重
              </div>
            </el-tooltip>
          </div>
          <template slot-scope="scope">
            {{ scope.row.amount||"-" }} {{ scope.row.currency||"-" }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 20px;">
        <el-button style="width: 120px;" size="small" @click="closedDialog">关闭</el-button>
      </div>
    </el-dialog>
    <use-platform-quotation-view-quotation
      :visible.sync="visibleQuotation"
      :id="viewQuotationId"
      @closed="hideQuotation"
    />
  </div>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import UsePlatformQuotationViewQuotation
  from "@/components/QuotationManagement/components-productQuotation/usePlatformQuotation/viewQuotation";
import {isObject} from "my-tools-kit";
import {rulesNotEmpty} from "@/assets/js/formRules";

export default {
  name: "priceCalculation",
  components: {UsePlatformQuotationViewQuotation},
  mixins:[mixinsDialog],
  props:{
    countryId:[Number,String],//国家id
    supplierIds:{
      type:Array,
      default:()=>[],
    },
  },
  data(){
    let rulesWeight = (rule, value, callback)=>{
      if([0,'0'].includes(value)) return callback(new Error('不能 <= 0'));
      let result = /^\d+(.\d+)?$/.test(`${value}`);
      if(!result) return callback(new Error('必须大于0的整数或小数'));
      // value = parseFloat(value);
      return callback();
    };
    let rulesNumber = (rule, value, callback)=>{
      if([0,'0'].includes(value)) return callback(new Error('不能 <= 0'));
      if(value){
        let result = /^\d+$/.test(`${value}`);
        if(!result) return callback(new Error('为空或大于0的整数'));
      }
      return callback();
    };
    return {
      /* 表单校验 */
      formRules: {
        no: [{trigger: 'blur', required: false}],
        require: [rulesNotEmpty()],
        weight:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:rulesWeight,},
        ],
        number:[
          // rulesNotEmpty(),
          {trigger:"blur", validator:rulesNumber,},
        ],
      },
      /* 筛选 */
      searchData:{
        cityId:"",//起运城市
        zipCode:"",//美国目的地邮编
        address:"",//详细地址
        goodsWeight:"",//货物总重量
        goodsVolume:"",//货物总体积
        goodsNumber:"",//货物总件数
      },
      startCityList:[],//起运城市列表
      loadingStartCity:false,

      // 列表
      loadingList:false,
      list:[],

      /* 查看报价 */
      visibleQuotation:false,
      viewQuotationId:"",
    }
  },
  watch:{
    isShow(val){
      if(val) setTimeout(()=>{
        this.getStartCityList()
      },100);
    }
  },
  methods:{
    /**
     * 关闭回调
     */
    closedCallback() {
      this.$emit('closed');
      this.resetData();
    },
    /**
     * 重置数据
     */
    resetData(){
      this.searchData = {
        cityId: "",//起运城市
        zipCode: "",//美国目的地邮编
        address: "",//详细地址
        goodsWeight: "",//货物总重量
        goodsVolume: "",//货物总体积
        goodsNumber: "",//货物总件数
      };

      this.loadingList = false;
      this.list = [];

      this.loadingStartCity = false;
      this.startCityList = [];

      this.viewQuotationId = "";
      this.visibleQuotation = false;
    },
    /**
     * 点击查询
     */
    clickSearch(){
      let formName = "searchForm";
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        // if(!this.searchData.cityId) return this.$message("缺少 起运城市");
        // if(!this.searchData.zipCode) return this.$message("缺少 美国目的地邮编");
        // if(!this.searchData.goodsWeight) return this.$message("缺少 货物总重量");
        // if(!this.searchData.goodsVolume) return this.$message("缺少 货物总体积");
        // if(!this.searchData.goodsNumber) return this.$message("缺少 货物总件数");
        this.getList();
      })

    },
    /**
     * 获取列表
     */
    getList(){
      let url = `/api/smartQuotedPrice/getQuotedPriceTrialInfo`;
      let data = {
        "address": this.searchData.address,//详细地址
        "carrierIdList": this.supplierIds||[],//供应商id
        "cbm": this.searchData.goodsVolume,//货物总体积
        "countryId": this.countryId,//国家id
        "departureCityId": this.searchData.cityId,//起运城市id
        "piece": this.searchData.goodsNumber,//件数
        "weight": this.searchData.goodsWeight,//货物总重量
        "zipCode": this.searchData.zipCode,//目的邮编
      };
      this.loadingList = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingList = false;
          let list = res.datas || [];
          this.list = list;
        })
        .catch(res=>{
          this.loadingList = false;
          this.list = [];
        })
    },
    /**
     * 获取海外仓城市列表
     */
    getStartCityList(id=this.countryId){
      let url = `/api/smartQuotedPrice/getDeliveryDepartureCityListByCountryId/${id}`;
      let data = {

      };
      this.loadingStartCity = true;
      this.axios.get(url,{params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingStartCity = false;
          let list = res.datas || [];
          this.startCityList = list;
        })
        .catch(res=>{
          this.loadingStartCity = false;
          this.startCityList = [];
        })
    },
    /**
     * 查看报价
     */
    showQuotation(item,index){
      this.viewQuotationId = item.quotedId;
      this.visibleQuotation = true;
    },
    hideQuotation(){
      this.viewQuotationId = "";
      this.visibleQuotation = false;
    },
  },
}
</script>

<style scoped lang="scss">
.common-input-width {
  width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/priceCalculation/index.vue